module.exports = __webpack_public_path__ + "img/tiktok-2.763d2cf1.svg";